var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{staticClass:"sr-radio",on:{"change":_vm.change},model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.list),function(op){return _c('el-radio',{key:op.dataValue,attrs:{"disabled":op.disabled || false,"label":_vm.item.label ? op[_vm.item.label] : op.dataValue,"name":op.dataValue}},[_vm._v(_vm._s(op.dataName))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080fa6b1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/SrRadio/SrRadio.vue
// module id = 215
// module chunks = 0